import { MemoryPerson } from 'src/types/models';

export const editablePersonPredicate = (
  memoryPerson: MemoryPerson,
): boolean => {
  return !memoryPerson.virtual_pet;
};
